import React from "react";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import CreatePollForm from "./CreatePollForm";

const CreatePoll = () => {
  return (
    <BoxLayout padding={[2.8, 3.7, 1.3, 2.4]}>
      <CreatePollForm />
    </BoxLayout>
  );
};

export default CreatePoll;
